import React from 'react';

import {
    Section,
    Typography,
} from 'wanderu-components';

import stars from './stars.svg';
import logo from './trustpilot-logo.svg';

import styles from './Trustpilot.scss';

function Trustpilot() {
    return (
        <Section className={styles.section} color="light" id="trustpilot-section">
            <a className={styles.link} href="https://www.trustpilot.com/review/www.wanderu.com?utm_medium=trustbox&amp;utm_source=TrustBoxBasic&amp;utm_campaign=free" rel="noreferrer" target="_blank">
                <img className={styles.logo} src={logo} width="120" />
                <div className={styles.ratings} >
                    <Typography className={styles.rating} variant="h5">4.8</Typography> <img className={styles.stars} src={stars} />
                </div>
                <Typography variant="body2">Based on 3k reviews</Typography>
            </a>
        </Section>
    );
}

export default Trustpilot;
